// extracted by mini-css-extract-plugin
export default {"rock_paper_scissors_container":"rock-paper-scissors_rock_paper_scissors_container__onO+s"};